export default "/images/card-image.svg?40be7cd534256e877bcd40c4a763cbba";